import { useState, useEffect, useRef, Fragment } from 'react'
import eventdata from "../data/events.json"
import Papa from 'papaparse'
import { useReactToPrint } from 'react-to-print';
import { CSVLink } from "react-csv";
import { useStateWithCallbackLazy } from 'use-state-with-callback';

const Participants = () => {
	const [event, setEvent] = useState(Object.keys(eventdata)[0]);
	const [isTeam, setIsTeam] = useState(false);
	const [data, setData] = useState([]);
	const [loading, setLoading] = useState(false);
	const [csvData, setCsvData] = useStateWithCallbackLazy([]);
	const componentRef = useRef();

	useEffect(() => {
		setIsTeam(eventdata[event].type === "team")
		fetchData();
		// console.log("fetching")
	}, [event]);

	const fetchData = async () => {
		const response = await fetch("https://docs.google.com/spreadsheets/d/e/2PACX-1vRPP1t7aXtfyB4ipXGiR0c0u077PlCgepfXodO5Wj7Tb4UZ95q5wjyF8VwKnGn-2V6iY16ssHBugm20/pub?gid=0&single=true&output=csv");
		const textData = await response.text();
		return setData(Papa.parse(textData, { header: true, skipEmptyLines: true }).data);
	}

	const handlePrint = useReactToPrint({
		content: () => componentRef.current,
	});

	const handleCSV = (e, done) => {
		if (!loading) {
			setLoading(true);
		}
		if (!isTeam) {
			setCsvData([
				["ChestNo", "House", "Name", "UID", "Sem", "Dept", "Division", "Slot"], ...data
					.filter(row => row.Event === event)
					.map((row) => [
						`${row["Code"]}`, `${row["House"]}`, `${row["Name-1"]}`, `${row["Uid-1"]}`, `${row["Semester-1"]}`, `${row["Department-1"]}`, `${row["Division-1"]}`
					])
			], () => {
				setLoading(false);
				// done(true);
				// console.log(csvData);
			});
		} else {
			setCsvData([
				["ChestNo", "House", "Name", "UID", "Sem", "Dept", "Division", "Slot"], ...data
					.filter(row => row.Event === event)
					.flatMap((row) =>
						[...Array(eventdata[event].no_of_members).keys()].map((i) => [row["Code"], row["House"], row[`Name-${i + 1}`], row[`Uid-${i + 1}`], row[`Semester-${i + 1}`], row[`Department-${i + 1}`], row[`Division-${i + 1}`]])
					)
			], () => {
				setLoading(false);
				done(true);
				// console.log(csvData);
			});
		}
	}

	return (
		<div className="overflow-auto">

			<h3 className="mt-6">Please select event to get list of participants.</h3>

			<div ref={componentRef} className="to-print">

				<div className="mt-6 mb-10 flex flex-col">
					<label htmlFor="Event" className="block text-xl font-semibold mb-2">Event</label>
					<select name="Event" value={event} onChange={(e) => setEvent(e.target.value)} className="block text-black w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded-sm shadow" required>
						{Object.keys(eventdata).map((event) => {
							return <option value={event} id={event}>{eventdata[event].title}</option>
						})}
					</select>
				</div>

				<div className="w-auto">
					<div className={`grid grid-cols-${isTeam ? "6" : "10"} text-center`}>
						{
							!isTeam ? (
								<Fragment>
									<div className="flex items-center justify-center border md:text-xl font-bold p-2 md:p-4">Index</div>
									<div className="border md:text-xl font-bold p-2 md:p-4">Chest No.</div>
									<div className="border md:text-xl font-bold p-2 md:p-4">House</div>
								</Fragment>
							)
								:
								null
						}
						<div className="border md:text-xl font-bold p-2 col-span-2 md:p-4">Name</div>
						<div className="border md:text-xl font-bold p-2 md:p-4">UID</div>
						<div className="border md:text-xl font-bold p-2 md:p-4">Sem</div>
						<div className="border md:text-xl font-bold p-2 md:p-4">Dept</div>
						<div className="border md:text-xl font-bold p-2 md:p-4">Division</div>
						{isTeam ? null : <div className="border md:text-xl font-bold p-2 md:p-4">Slot</div>}
					</div>
					{
						data
							.filter(row => row.Event === event)
							.map((row, index) => {
								if (isTeam) {
									return (
										<div className="grid grid-cols-6 mt-10 text-center">

											<div className="col-span-full border-x border-t p-2 font-semibold text-sm md:text-base md:p-2 uppercase">Chest No : {row["Code"]}</div>
											<div className="col-span-full border-x border-b py-2 font-semibold text-sm md:text-base md:p-2">House : {row["House"]}</div>
											<div className="text-left col-span-full border-x border-b py-2 font-semibold text-sm md:text-base md:p-2">Slot :</div>

											{[...Array(eventdata[event].no_of_members)].map((e, i) => {
												return (
													<Fragment>
														<div className="flex items-center justify-center border-x border-y p-2 text-sm col-span-2 md:text-base md:p-2">{row[`Name-${i + 1}`]}</div>
														<div className="flex items-center justify-center border-x border-y p-2 text-sm md:text-base md:p-2">{row[`Uid-${i + 1}`]}</div>
														<div className="flex items-center justify-center border-x border-y p-2 text-sm md:text-base md:p-2">{row[`Semester-${i + 1}`]}</div>
														<div className="flex items-center justify-center border-x border-y p-2 text-sm md:text-base md:p-2">{row[`Department-${i + 1}`]}</div>
														<div className="flex items-center justify-center border-x border-y p-2 text-sm md:text-base md:p-2">{row[`Division-${i + 1}`]}</div>
													</Fragment>
												)
											})}

										</div>
									);
								} else {
									return (
										<div className="grid grid-cols-10 text-center">
											<div className="row-span-3 border-x border-y p-2 font-semibold text-sm overflow-auto md:text-base md:p-2 uppercase">{index + 1}</div>
											<div className="row-span-3 border-x border-y p-2 font-semibold text-sm overflow-auto md:text-base md:p-2 uppercase">{row["Code"]}</div>
											<div className="row-span-3 border-x border-y py-2 font-semibold text-sm overflow-auto md:text-base md:p-2">{row["House"]}</div>

											<div className="flex items-center justify-center border-x border-y p-2 text-sm overflow-auto col-span-2 md:text-base md:p-2">{row["Name-1"]}</div>
											<div className="flex items-center justify-center border-x border-y p-2 text-sm overflow-auto md:text-base md:p-2">{row["Uid-1"]}</div>
											<div className="flex items-center justify-center border-x border-y p-2 text-sm overflow-auto md:text-base md:p-2">{row["Semester-1"]}</div>
											<div className="flex items-center justify-center border-x border-y p-2 text-sm overflow-auto md:text-base md:p-2">{row["Department-1"]}</div>
											<div className="flex items-center justify-center border-x border-y p-2 text-sm overflow-auto md:text-base md:p-2">{row["Division-1"]}</div>
											<div className="flex items-center justify-center border-x border-y p-2 text-sm md:p-2"></div>
										</div>
									);
								}
							})
					}
				</div>
			</div>

			<div className="my-8">
				<button className="inline-flex items-center px-4 py-2 my-2 border border-transparent text-base font-semibold rounded-sm shadow-sm text-white bg-amber-500 hover:bg-amber-600" onClick={handlePrint}>Print Participants</button>
				<CSVLink data={csvData} filename={`${event}_participant_list.csv`} asyncOnClick={true} className="inline-flex items-center px-4 py-2 my-2 md:ml-8 border border-transparent text-base font-semibold rounded-sm shadow-sm text-white bg-amber-500 hover:bg-amber-600" onClick={handleCSV}>{loading ? 'Loading CSV...' : 'Download CSV (experimental)'}</CSVLink>
			</div>

		</div>
	);
};

export default Participants;
